'use client';

import { useCurrentConfig } from '@wwe-portal/web/providers/queries/global';
import { Flag } from '@wwe-portal/entities/global.type';
import { FC } from 'react';
import { experimentFlags } from '@wwe-portal/web/utils/constants/experiments';
import { AbTesting } from '../ab-testing';

export const useEnabledFlag = (flag: Flag) => {
  const { finalConfig: config, isLoading } = useCurrentConfig();
  return {
    enabled: Boolean(config?.[flag]),
    isLoading,
  };
};

export const useEnabledFlags = (flags: Flag[]) => {
  const { finalConfig: config, isLoading } = useCurrentConfig();
  return {
    enabled: flags.map((flag) => Boolean(config?.[flag])),
    isLoading,
  };
};

export const FeatureFlag: FC<{
  flag: Flag;
  children: React.ReactNode;
  fallback?: React.ReactNode;
  placeholder?: React.ReactNode;
}> = ({ flag, children, fallback = null, placeholder = null }) => {
  const { enabled, isLoading } = useEnabledFlag(flag);
  const experimentFlag = experimentFlags[flag];

  if (isLoading) {
    return placeholder;
  }

  if (experimentFlag) {
    return (
      <AbTesting
        feature={experimentFlag}
        options={{
          allowAnonymous: enabled,
        }}
        placeholder={placeholder}
        fallback={fallback}
      >
        {children}
      </AbTesting>
    );
  }

  return enabled ? children : fallback;
};
